import { pageSize } from '../../Components/helper';

export { months, monthsPlaceholder, YearsWithId } from '../../Components/helper';

export const PLACEHOLDER_ROUTES = {
  BASE: '/placeholder-management',
  CARD_ADD: '/placeholder-management-card/add',
  CARD_EDIT: '/placeholder-management-card/edit',
  LIST: '/placeholder-management-list',
  PRODUCT_EDIT: '/development-order-overview/edit',
} as const;

export const PAGE_SIZE = pageSize;

/**
 * i18next namespace holding this module's own strings (registered in `src/index.js`).
 * Backend error keys are mirrored under it so `errMsg` values translate directly.
 */
export const PLACEHOLDER_I18N_NAMESPACE = 'modules/placeholder-management';
